export class SpConstantAlert {

    /**
     * @param {('success'|'info'|'warning'|'danger')} type
     * @param {string} key - A translation key
     * @param {object} variables - key-value pairs for variable replacement
     *     {@link https://angular-translate.github.io/docs/#/guide/06_variable-replacement}
     * @param {boolean} [autoDismiss=true] - Dismiss after some timeout. Default true.
     *
     * @example
     * // Most common usage. Translate and display an auto-dismissed message
     * new SpAlert('success', 'global.messages.success')
     *
     * @example
     * // Disable auto-dismiss
     * new SpAlert('warning', 'global.messages.warning', {}, false)
     *
     * @example
     * // If translation key contains interpolated variables, pass an object as second parameter
     * new SpAlert('info', 'global.messages.info', {user: 'John'})
     */
    constructor(type, key, variables = {}, autoDismiss = false,showButton=false, buttonLabel='',nextState=null) {
        this.type = type;
        this.key = key;
        this.variables = variables;
        this.autoDismiss = autoDismiss;
        this.showButton = showButton;
        this.buttonLabel = buttonLabel;
        this.nextState=nextState;
        
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-constant-alert/sp-constant-alert.model.js